import React, { useEffect } from "react";
import styles from "./IRLHero.module.css";
// Import Font Awesome icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRobot } from "@fortawesome/free-solid-svg-icons";
import AOS from "aos";
import "aos/dist/aos.css";
import {
  FaArrowRight,
  FaPalette,
  FaPallet,
  FaRocket,
  FaThemeco,
} from "react-icons/fa";

const IRLHero = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const handleDemoClick = (name) => {
    const formElement = document.getElementById(name);
    if (formElement) {
      formElement.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <div className={styles.hero} data-aos="fade-in">
      <div className={styles.content} data-aos="fade-up">
        <div className={styles.heroText}>
          <h1>
            WELCOME TO <br />
            <span className={styles.highlight}>INDIA ROBOTICS LEAGUE</span> -
            SEASON {new Date().getFullYear() - 2019}
          </h1>
        </div>
        <div className={styles.heroSubtext}></div>
        <p className={styles.theme}>
          Theme: <span className={styles.highlight}>Food For All</span> - A
          Journey Towards Sustainable Eating
        </p>
        {window.innerWidth < 768 ? (
          <div className={styles.blueText}>
            Join us for India's Biggest Robotics Competition
          </div>
        ) : (
          <span className={styles.blueText}>
            Join us for India's Biggest Robotics Competition
          </span>
        )}
        <div className={styles.buttons} data-aos="fade-up" data-aos-delay="300">
          <button
            className={styles.primary}
            onClick={() => handleDemoClick("about-irl")}
          >
            About IRL <FaRocket />
          </button>
          <button
            className={styles.secondary}
            onClick={() => handleDemoClick("theme-info")}
          >
            <div className="button_content">
              {" "}
              Explore Themes <FaPalette className={styles.icon} />
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default IRLHero;
